import React from "react";
import { Field, BaseProps } from "./field";
import { InputAdornment } from "@material-ui/core";
import { Event as EventIcon } from "@material-ui/icons";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

type Props = BaseProps<MaterialUiPickersDate> & {
  disableFuture?: boolean;
  disablePast?: boolean;
};

export const Datebox: React.FC<Props> = (props) => {
  function onChange(date: MaterialUiPickersDate) {
    if (props.onChange) {
      props.onChange(props.name, date);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          autoOk
          disabled={props.disabled}
          disableFuture={props.disableFuture}
          disablePast={props.disablePast}
          disableToolbar
          error={!!props.error}
          format="M/d/yyy"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EventIcon fontSize="small" color="disabled" />
              </InputAdornment>
            ),
          }}
          name={props.name}
          onChange={onChange}
          required={props.required}
          value={props.value || null}
          variant="inline"
        />
      </MuiPickersUtilsProvider>
    </Field>
  );
};
